import type { FC } from "react";
import type { CategoryScoringMap } from "../../api/dto";
import { getScoreClassification, scoreBadgeStyle } from "../../util/categoryScoring";
import { Badge } from "./Badge";

export const ScoreBadge: FC<{
  scoringMap: CategoryScoringMap;
  category: string;
  score: number;
}> = ({ scoringMap, category, score }) => {
  const classification = getScoreClassification(scoringMap, category, score);
  return (
    <Badge style={scoreBadgeStyle[classification?.color ?? ""]}>
      {score} - {classification?.classification ?? "-"}
    </Badge>
  );
};
